import { useEffect, useState } from 'react';
import type { ConversationStats } from 'types/stats';
import { fetchConversationStats } from 'utils/statsCLient';

type UseConverstionStatResult = {
  stat: ConversationStats | null;
  loading: boolean;
  error: Error | null;
};

export function UseConverstionStats(): UseConverstionStatResult {
  const [stat, setStat] = useState<ConversationStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchStats = async () => {
      try {
        setLoading(true);
        const data = await fetchConversationStats();
        if (cancelled) return;
        setStat(data);
        setError(null);
      } catch (err) {
        if (cancelled) return;
        setError(err as Error);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchStats();

    const interval = setInterval(fetchStats, 300_000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return { stat, loading, error };
}
